import styled from 'styled-components';
import { palette } from '../../styles/theming/Theme';
const dividerColorOptions = {
    light: palette.grey[5],
    regular: palette.grey[8],
    dark: palette.grey[12]
};
const sizeOptions = {
    small: '6px',
    regular: '10px',
    large: '14px'
};
export const Item = styled.li `
  border-top:
    ${({ hasDivider, dividerColor }) => (hasDivider ? `1px solid ${dividerColorOptions[dividerColor]}` : 'none')};
  list-style: none;
  width: 100%;
  text-align: ${({ align }) => align || 'left'};
  border-radius: ${({ hasBorderRadius }) => hasBorderRadius && '5px'};
  color: ${palette.grey[12]};
  cursor: pointer;
  box-sizing: border-box;

  &:first-child {
    border-top: ${({ hasDivider, hasFirstDivider, dividerColor }) => hasDivider && hasFirstDivider
    ? `1px solid ${dividerColorOptions[dividerColor]}`
    : 'none'};
  }

  &:hover {
    background: ${palette.background};
  }

  p, span, h1, h2, h3, h4, h5, h6 {
    padding: ${({ size }) => `${sizeOptions[size]} 15px`};

    &:hover {
      color: ${palette.primary.regular};
    }
  }
`;
//# sourceMappingURL=styles.js.map